import React from 'react'
import { List } from 'semantic-ui-react'
import { connect } from 'react-redux'

const TabSkillContent = ({myskill}) => (
  <div className="tab-skill-content">
      {myskill.map((v,k)=>(
        <div className="skill-contents" key={k}>
          <h3 className="skill-title" >{v.title}</h3>
          <List as='ul' key={k+"II"}>
            {v.list.map((v2, k2)=>(
              <List.Item as='li' value='*' key={k2+"III"}>{v2}</List.Item>
            ))}
          </List> 
        </div> 
      ))}
  </div>
)


const mapStateToProps = (state, props) => {
  return {
    myskill: props.tab_skills_content,
  }
}

const myAppComp = connect(
  mapStateToProps
)(TabSkillContent)

export default myAppComp


// WEBPACK FOOTER //
// ./src/components/TabSkillContent.js